

@if (loaded) {
@for (field of question.fields; track field.id) {
	<div>
	@switch (field.type) {
		@case ('number') {
			<div class="label-container text-accent">
				<label class="title">{{ field.text }}</label>
				@if (field.value) {
					<label class="value">#{{ field.value }}</label>
				}
			</div>
			<div class="d-flex justify-content-center">
				<mat-slider
					color="primary"
					[max]="field.max"
					[min]="field.min"
					[step]="1"
					[discrete]="true"
					[showTickMarks]="true">
					<input matSliderThumb [(ngModel)]="field.value">
				</mat-slider>
			</div>
		}
		@case ('amount') {
			<div class="label-container text-accent">
				<label class="title">{{ field.text }}</label>
				<label class="value">{{field.value | lcurrency}}</label>
			</div>
			<div class="d-flex justify-content-center">
				<mat-slider
					color="primary"
					[max]="field.max"
					[min]="field.min"
					[step]="field.step"
					[discrete]="true"
					[showTickMarks]="true">
					<input matSliderThumb [(ngModel)]="field.value" >
				</mat-slider>
			</div>
		}
		@case ('chips') {
			<div class="label-container text-accent">
				<label class="title">{{ field.text }}</label>
			</div>
			<div class="_chip-set">
				@for (chip of field.members; track chip.id) {
					<div class="_chip" [class.active]="field.value.includes(chip.value)" (click)="toggleChip(field, chip.value)">
						<span>{{ chip.value }}</span>
					</div>
				}
			</div>
		}
	}
	</div>
}
	<div class="text-center pb-4 mt-3">
		<button mat-flat-button color="accent" (click)="_apply()" style="min-width: 95%; height: 50px; font-weight: 700;">
			{{'tabot.find_me' | translate}}
		</button>
	</div>

}
